import { post } from '@/helpers/api'
import { uuid } from '@/helperMethods'
import { storage } from '@/helpers/utils'

export const updateDevice = async (payload) => {
	try {
		const { data } = await post('/api/v1/device.update', payload)
		return data
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const enablePushNotifications = async (pushtoken) => {
	try {
		pushtoken = pushtoken || uuid()
		const response = await updateDevice({ pushtoken })
		cachePushToken(pushtoken)
		return response
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const cachePushToken = (pushtoken) => {
	storage.set('pushtoken', pushtoken)
}

export const clearPushToken = () => {
	storage.remove('pushtoken')
}

export const getPushToken = () => {
	return storage.get('pushtoken') || null
}
